import { FunctionComponent, ReactNode } from "react";
import { Card } from "@chakra-ui/react";

type Props = {
  children: ReactNode;
  bg?: string;
  color?: string;
  borderWidth?: string | number;
  borderColor?: string;
  borderStyle?: string;
  padding?: number | string | object;
  borderRadius?: number | string;
  borderBottom?: string;
  borderTop?: string;
  borderLeft?: string;
  borderRight?: string;
  boxShadow?: string;
  width?: number | string | object;
  margin?: number | string;
  height?: number | string | object;
  overflowX?: "scroll" | "hidden";
  overflowY?: "scroll" | "hidden";
};

export const CustomCard: FunctionComponent<Props> = ({
  children,
  bg,
  color,
  borderWidth,
  borderColor,
  borderStyle,
  borderRadius,
  borderBottom,
  borderLeft,
  borderRight,
  borderTop,
  padding,
  boxShadow,
  width,
  margin,
  height,
  overflowX,
  overflowY,
}) => {
  return (
    <Card
      bg={bg}
      color={color}
      p={padding}
      borderStyle={borderStyle}
      borderWidth={borderWidth}
      borderColor={borderColor}
      borderBottom={borderBottom}
      borderTop={borderTop}
      borderLeft={borderLeft}
      borderRight={borderRight}
      boxShadow={boxShadow}
      borderRadius={borderRadius}
      width={width}
      m={margin}
      h={height}
      overflowX={overflowX}
      overflowY={overflowY}
    >
      {children}
    </Card>
  );
};
